<template>
  <div :id="$options.consts.ELEMENT_ID.WINNERS_SECTION">
    <div class="winners-winners-section__wrapper">
      <h2 class="winners-winners-section__title title uppercase">
        CONGRATULATIONS TO ALL WINNERS
      </h2>

      <p class="winners-winners-section__text text-body">
        Congratulations to all the Finance Magnates Awards 2025 winners!
      </p>

      <p class="winners-winners-section__text text-body">
        Your innovation and leadership have made a real mark in the financial
        industry. This recognition reflects the trust and respect earned from
        both peers and experts.
      </p>

      <p class="winners-winners-section__text text-body">
        Thank you to everyone who took part, nominees, voters, and judges, for
        making this year’s awards a success.
      </p>
    </div>

    <div class="winners-winners-section-categories__wrapper">
      <winners-winners-section-categories :winners="WINNERS" />
    </div>
  </div>
</template>

<script>
import { ELEMENT_ID } from 'enums/element-id'
import WinnersWinnersSectionCategories from './WinnersWinnersSectionCategories'
import { WINNERS } from './enums'

export default {
  name: 'HomepageWinnersSection',
  components: {
    WinnersWinnersSectionCategories
  },
  consts: { ELEMENT_ID },
  data() {
    return {
      WINNERS
    }
  }
}
</script>

<style scoped lang="scss">
@import '~assets/scss/local/mixins/grid';

.winners-winners-section__wrapper {
  padding: 64px 0;

  .winners-winners-section__title {
    margin-bottom: 24px;
  }

  .winners-winners-section__text {
    margin-bottom: 14px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .winners-winners-section-cards__wrapper {
    margin-top: 64px;
  }
}
</style>
